"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZMultiSelect = void 0;
const React = __importStar(require("react"));
const kendo_react_dropdowns_1 = require("@progress/kendo-react-dropdowns");
const __1 = require("..");
const themeUtils_1 = require("../../utils/themeUtils");
const useLocalizedProps_1 = require("../../languages/useLocalizedProps");
const styled_components_1 = __importDefault(require("styled-components"));
const ZMultiSelectComponent = (props) => {
    const { languageId, label, className, tagColorKey, required, ...multiSelectProps } = useLocalizedProps_1.useLocalizedProps({
        propsToLocalize: ["label"],
        ...props
    });
    const [labelIsRaised, setLabelIsRaised] = React.useState(props.value && props.value.length > 0);
    const tagRender = tagColorKey
        ? (tagData, li) => {
            return React.cloneElement(li, li.props, React.createElement("span", { style: {
                    color: themeUtils_1.fixColor({
                        hex: tagData.data[0][tagColorKey],
                        elem: "#ffffff"
                    }),
                    backgroundColor: tagData.data[0][tagColorKey],
                    borderRadius: "2em",
                    padding: "0px 10px",
                    margin: "-3px -8px",
                    display: "inline-flex",
                    alignItems: "center"
                } }, li.props.children));
        }
        : undefined;
    return (React.createElement("div", { className: className },
        React.createElement(__1.RequiredDot, { required: required, raised: labelIsRaised, raisedTransform: "up-5 left-16", loweredTransform: "down-21 left-10" },
            React.createElement(kendo_react_dropdowns_1.MultiSelect, Object.assign({ label: label, autoClose: false, tagRender: tagRender }, multiSelectProps, { onOpen: event => {
                    if (props.onOpen) {
                        props.onOpen(event);
                    }
                    setLabelIsRaised(true);
                }, onClose: event => {
                    if (props.onClose) {
                        props.onClose(event);
                    }
                    setLabelIsRaised(props.value && props.value.length > 0);
                }, onChange: event => {
                    if (props.onChange) {
                        props.onChange(event);
                    }
                    setLabelIsRaised(event.value && event.value.length > 0);
                } })))));
};
exports.ZMultiSelect = styled_components_1.default(ZMultiSelectComponent) `
   margin: 10px;
   .k-textbox-container {
      min-width: 300px;
   }

   .k-textbox-container:not(.k-state-empty) > .k-label {
      margin: -5px;
   }
   .k-multiselect .k-multiselect-wrap {
      min-width: 200px;
   }
   .k-dropdowntree .k-multiselect-wrap .k-button .k-select {
      background-color: transparent;
      color: white;
      position: relative;
      left: 4px;
      top: 0.5px;
   }

   .k-multiselect .k-multiselect-wrap .k-button.k-state-hover,
   .k-dropdowntree .k-multiselect-wrap .k-button.k-state-hover,
   .k-multiselect .k-multiselect-wrap .k-button:hover,
   .k-dropdowntree .k-multiselect-wrap .k-button:hover {
      color: white;
      background-color: rgba(0, 0, 0, 0.3);
   }
   &.k-button {
      margin: 5px;

      &.k-primary:not(.k-state-disabled) {
         background: ${props => props.theme["app-link-color"]};
         color: ${props => props.theme["action-button-hover-text-color"]} !important ;
         &:hover {
            background: ${props => props.theme["hover-color"]};
            color: ${props => props.theme["action-button-hover-text-color"]} !important;
         }
         &:active {
            background: ${props => props.theme["active-color"]};
         }
      }
      &:hover {
         background: ${props => props.theme["hover-color"]};
         color: ${props => props.theme["action-button-hover-text-color"]} !important;
      }
      &:active {
         color: ${props => props.theme["active-color"]};
      }
      background: ${props => {
    if (props.disabled) {
        return props.theme["action-button-disabled-color"];
    }
    else {
        return props.theme["action-button-background-color"];
    }
}};
      color: ${props => {
    return props.theme["action-button-color"];
}};
      font-weight: bold;
      font-family: ${props => props.theme["font-family"]};
   }
   .k-list .k-item.k-state-selected.k-state-selected.k-state-selected {
      color: ${p => p.theme["action-button-hover-text-color"]};
      background-color: ${p => p.theme["selected-background-color"]};
      border-color: ${p => p.theme["selected-background-color"]};
   }
`;
//# sourceMappingURL=ZMultiSelect.js.map